import React from 'react'

export default function Footer() {
  return (
    <div className='justify-center text-center w-full text-lg p-5'>© Wolfer - X_Shadow_ {new Date().getFullYear()} - All rights reserved</div>
  )
}
